export const PLAYER_RANKS = "初士杰豪圣魂";
export const RANK_LABELS = ["一位", "二位", "三位", "四位"];
